<template>
  <div>
    <div class="flex nav-header">
      <div class="nav-headerL">
        <a href="https://kittyhow.com/">知视猫</a>
      </div>

      <div class="nav-headerR flex">
        <div v-for="item of navList">
          <a v-if="item.linkUrl!='/home'" :href="item.linkUrl" @click="chooseNav==item.linkUrl">{{ item.title }}</a>
          <a v-else href="https://kittyhow.com/login" target="_blank">{{ item.title }}</a>
        </div>
      </div>
    </div>
    <router-view />

    <zsmService />
    <zsmFooter />
  </div>
</template>

<script>
import zsmFooter from './footer.vue'
import zsmService from './service.vue'
export default {
  components: {
    zsmFooter, zsmService
  },
  data() {
    return {
      navList: [{
        title: '首页',
        linkUrl: 'https://kittyhow.com/'
      },
      {
        title: '解决方案',
        linkUrl: 'https://kittyhow.com/solution'
      },
      /*  {

            title: '招商加盟',
            // title: '业务合作',
            linkUrl: 'https://kittyhow.com/brand'
          }, */
      // {
      //   title:'功能介绍',
      //   linkUrl:'/'
      // },
      // {
      //   title:'新闻动态',
      //   linkUrl:'/'
      // },
      {
        title: '关于我们',
        linkUrl: 'https://kittyhow.com/about-us'
      },
      {
        title: '学员中心',
        linkUrl: 'http://kittyhow.com/study'
      },
      /*  {
            title: '代理商服务',
            linkUrl: 'https://kittyhow.com/login/#/agent'
          }, */
      {
        title: '创作者服务',
        linkUrl: '/home'
      }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-header {
    height: 80px;
    align-items: center;
    line-height: 20px;
    justify-content: space-between;
    text-align: center;
    position: relative;
    z-index: 999;

    .nav-headerL {
      width: 80px;
      height: 25px;
      margin-left: 91px;
      display: flex;
      align-items: center;
      font-size: 24px;

    }

    .nav-headerR {
      margin: 0 76px 0 0;
      padding: 0;
      min-width: 900px;
      flex: 1;
      justify-content: flex-end;

      .router-link-exact-active {
        color: #ff2442;

        &::before {
          position: absolute;
          bottom: -8px;
          visibility: hidden;
          content: "";
          width: 100%;
          height: 2px;
          background-color: #ff2442;
          transform: translateX(-100%);
          border-radius: 2px;
          opacity: 0;
        }
      }

      div {
        cursor: pointer;
        color: #555;
        margin-left: 58px;
        // width: 16%;
        // text-align: right;
        // min-width: 150px;
        // max-width: 220px;
        // margin-left: 190px;
      }
    }
  }
</style>
